import {HierarchicNode} from '../../core/definitions/hierarchic-objects';
import {Reference} from '../../core/definitions/reference';

export function isLoadMoreHierarchicNode(node: HierarchicNode | null | undefined): boolean {
  return !!node && node.$$nodeType === 'loadMoreNode';
}

export function shouldSelectHierarchicDescendants(reference: Reference | null | undefined): boolean {
  return !!reference?.hierarchic_select_descendants;
}

export function collectHierarchicNodeAndDescendants(node: HierarchicNode | null | undefined): HierarchicNode[] {
  const out: HierarchicNode[] = [];
  const walk = (current: HierarchicNode | null | undefined) => {
    if (!current || isLoadMoreHierarchicNode(current)) {
      return;
    }
    out.push(current);
    for (const child of current.children || []) {
      walk(child);
    }
  };
  walk(node);
  return out;
}

export function hierarchicArrayNodesToToggle(
  node: HierarchicNode | null | undefined,
  isUnchecking: boolean,
  selectDescendants: boolean,
): HierarchicNode[] {
  if (!node || isLoadMoreHierarchicNode(node)) {
    return [];
  }
  if (isUnchecking || !selectDescendants) {
    return [node];
  }
  return collectHierarchicNodeAndDescendants(node);
}
